module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "UserAccount"
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "g-bg-img-hero",
    staticStyle: {
      "background-image": "url('../../../../static/assets/include/svg/svg-bg1.svg')",
      "background-attachment": "fixed"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isSuccess) ? _c('div', {
    staticClass: "alert alert-success center alert-fixed"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Changes Successfully Saved!")]) : _vm._e()]), _vm._v(" "), (_vm.isLoading || _vm.isLoadingEdit) ? _c('div', {
    staticClass: "row g-pt-100"
  }, [_c('page-loader')], 1) : _c('div', {
    staticClass: "container account_info g-pt-70 g-pb-100"
  }, [_c('br', {
    attrs: {
      "id": "errorDiv"
    }
  }), _vm._v(" "), (_vm.Account.accountType != 1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12 col-xs-12 account_header btn-group account_header btn-group"
  }, [_c('span', {
    staticClass: "btn active g-bg-main  g-color-white",
    attrs: {
      "href": "#"
    }
  }, [_c('h4', {
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.SwitchTab('account', $event)
      }
    }
  }, [_vm._v("Account & Contact")])]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "href": "#"
    }
  }, [_c('h4', {
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.SwitchTab('doctors', $event)
      }
    }
  }, [_vm._v("Eye Doctors")])])])]) : _c('div', {
    staticClass: "account_header"
  }, [_c('p', {
    staticClass: "header_title"
  }, [_vm._v("My Account")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageShown == 'account'),
      expression: "pageShown == 'account'"
    }],
    staticClass: "row"
  }, [_c('login-info', {
    attrs: {
      "AccountView": _vm.AccountView,
      "LoginFormInputs": _vm.LoginFormInputs,
      "LoginEdit": _vm.LoginEdit,
      "isFormLoading": _vm.isFormLoading
    },
    on: {
      "clicked": function($event) {
        return _vm.GetEditValues()
      },
      "selfReload": function($event) {
        return _vm.GetAccountValues()
      },
      "load": function($event) {
        return _vm.StartLoad()
      },
      "success": function($event) {
        return _vm.SuccessFade()
      }
    }
  }), _vm._v(" "), _c('account-info', {
    attrs: {
      "AccountView": _vm.AccountView,
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "AccountValidationResult": _vm.AccountValidationResult,
      "BusinessTypeIndividual": _vm.BusinessTypeIndividual,
      "BusinessTypeBusiness": _vm.BusinessTypeBusiness,
      "BusinessTypeNonProfit": _vm.BusinessTypeNonProfit,
      "Suffix": _vm.Suffix,
      "RoleNonProfit": _vm.RoleNonProfit,
      "RoleBusiness": _vm.RoleBusiness,
      "State": _vm.State,
      "isFormLoading": _vm.isFormLoading
    },
    on: {
      "clicked": function($event) {
        return _vm.GetEditValues()
      },
      "selfReload": function($event) {
        return _vm.GetAccountValues()
      },
      "load": function($event) {
        return _vm.StartLoad()
      },
      "success": function($event) {
        return _vm.SuccessFade()
      }
    }
  }), _vm._v(" "), _c('location-info', {
    attrs: {
      "AccountView": _vm.AccountView,
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "State": _vm.State,
      "RoleNonProfit": _vm.RoleNonProfit,
      "RoleBusiness": _vm.RoleBusiness,
      "isFormLoading": _vm.isFormLoading
    },
    on: {
      "clicked": function($event) {
        return _vm.GetEditValues()
      },
      "selfReload": function($event) {
        return _vm.GetAccountValues()
      },
      "load": function($event) {
        return _vm.StartLoad()
      },
      "success": function($event) {
        return _vm.SuccessFade()
      }
    }
  }), _vm._v(" "), _c('forecasting-info', {
    attrs: {
      "AccountView": _vm.AccountView,
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "isFormLoading": _vm.isFormLoading
    },
    on: {
      "clicked": function($event) {
        return _vm.GetEditValues()
      },
      "selfReload": function($event) {
        return _vm.GetAccountValues()
      },
      "load": function($event) {
        return _vm.StartLoad()
      },
      "success": function($event) {
        return _vm.SuccessFade()
      }
    }
  }), _vm._v(" "), (_vm.Account.accountType == 1) ? _c('eye-doctor-info', {
    attrs: {
      "AccountView": _vm.AccountView,
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "Suffix": _vm.Suffix,
      "State": _vm.State,
      "CheckboxIndividual": _vm.CheckboxIndividual,
      "isFormLoading": _vm.isFormLoading,
      "AccountValidationResult": _vm.AccountValidationResult,
      "NewDoctor": _vm.NewDoctor
    },
    on: {
      "clicked": function($event) {
        return _vm.GetEditValues()
      },
      "selfReload": function($event) {
        return _vm.GetAccountValues()
      },
      "load": function($event) {
        return _vm.StartLoad()
      },
      "success": function($event) {
        return _vm.SuccessFade()
      },
      "refreshDoctorForm": function($event) {
        return _vm.RefreshAddDoctorForm()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('association-info', {
    attrs: {
      "AccountView": _vm.AccountView,
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "AccountValidationResult": _vm.AccountValidationResult,
      "isFormLoading": _vm.isFormLoading,
      "CheckboxBusiness": _vm.CheckboxBusiness
    },
    on: {
      "clicked": function($event) {
        return _vm.GetEditValues()
      },
      "selfReload": function($event) {
        return _vm.GetAccountValues()
      },
      "load": function($event) {
        return _vm.StartLoad()
      },
      "success": function($event) {
        return _vm.SuccessFade()
      }
    }
  }), _vm._v(" "), _c('communication-info', {
    attrs: {
      "AccountView": _vm.AccountView,
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "isFormLoading": _vm.isFormLoading
    },
    on: {
      "clicked": function($event) {
        return _vm.GetEditValues()
      },
      "selfReload": function($event) {
        return _vm.GetAccountValues()
      },
      "load": function($event) {
        return _vm.StartLoad()
      },
      "success": function($event) {
        return _vm.SuccessFade()
      }
    }
  })], 1), _vm._v(" "), (_vm.Account.accountType != 1) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageShown == 'doctors'),
      expression: "pageShown == 'doctors'"
    }],
    staticClass: "row"
  }, [_c('eye-doctor-info', {
    attrs: {
      "AccountView": _vm.AccountView,
      "AccountEdit": _vm.AccountEdit,
      "FormInputs": _vm.FormInputs,
      "Suffix": _vm.Suffix,
      "State": _vm.State,
      "CheckboxIndividual": _vm.CheckboxIndividual,
      "isFormLoading": _vm.isFormLoading,
      "AccountValidationResult": _vm.AccountValidationResult,
      "NewDoctor": _vm.NewDoctor
    },
    on: {
      "clicked": function($event) {
        return _vm.GetEditValues()
      },
      "selfReload": function($event) {
        return _vm.GetAccountValues()
      },
      "load": function($event) {
        return _vm.StartLoad()
      },
      "success": function($event) {
        return _vm.SuccessFade()
      },
      "refreshDoctorForm": function($event) {
        return _vm.RefreshAddDoctorForm()
      }
    }
  })], 1) : _vm._e()])])])], 1)]), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c9445fda", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9445fda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/userAccount/UserAccount.vue
// module id = 551
// module chunks = 3